<template>
  <section :id="$style.shop_visual">
    <div :class="$style.left_area">
      <main-title
        v-observe-visibility="visibilityChanged_title"
        :class="{[$style.position]: true, ['animated slideInDown']: isVisible_title}"
        :main_title="'ショップ'"
        :sub_title="'Shop Information'"
        :color="'#403f3f'"
      ></main-title>
      <div :class="[$style.explain, $style.position]">ミュージアムの売店で販売しているグッズおよびグッズ価格をご覧いただくことができます。</div>
      <more-info-big-button
        v-observe-visibility="visibilityChanged_btn"
        :class="{[$style.position]: true, ['animated slideInUp']: isVisible_btn}"
        :title="'Shop Info'"
        :link="'/shop'"
        :color="'#403f3f'"
        :background="'#F8F1DD'"
      ></more-info-big-button>
    </div>
    <div :class="$style.right_area">
      <figure :id="$style.shop_fig"></figure>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import MoreInfoBigButton from "@/components/atoms/MoreInfoBigButton.vue";

export default Vue.extend({
  name: "ShopHomeVisual",

  components: {
    MainTitle,
    MoreInfoBigButton
  },
  data() {
    return {
      isVisible_title: Boolean,
      isVisible_btn: Boolean
    };
  },
  methods: {
    visibilityChanged_title(isVisible) {
      this.isVisible_title = isVisible;
    },
    visibilityChanged_btn(isVisible) {
      this.isVisible_btn = isVisible;
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $fig_height: 200px;
  $fig_width: 300px;

  #shop_visual {
    display: grid;
    grid-template-columns: 1fr repeat(3, 100px) 1fr;
    grid-template-rows: 60px 1fr 60px;
    background-color: #f8f1dd;
    position: relative;
    z-index: 1;
  }

  .position {
    margin: auto;
  }
  // タイトルを中央揃え
  .position:nth-child(1) {
    text-align: center !important;
  }

  .left_area {
    grid-column: 2/5;
    grid-row: 2/3;
    margin: auto;
    .explain {
      width: 255px;
      margin-top: 255px;
      margin-bottom: 25px;
      font-size: 13px;
    }
  }

  .right_area {
    grid-column: 2/5;
    grid-row: 2/3;
    #shop_fig {
      height: $fig_height;
      width: $fig_width;
      border-radius: 30px;
      background-image: url("../../../assets/shop.jpg");
      background-size: $fig_width $fig_height;
      background-repeat: no-repeat;
      margin: 0;
      margin-top: 80px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  $fig_height: 200px;
  $fig_width: 300px;

  #shop_visual {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f1dd;
    height: 500px;
  }

  // .left_areaのタグを右揃えにする
  .position {
    margin-left: auto;
  }

  .left_area {
    .explain {
      width: 255px;
      margin-top: 40px;
      margin-bottom: 30px;
      font-size: 16px;
    }
  }

  .right_area {
    margin-top: 31px;
    margin-left: 56px;
    #shop_fig {
      height: $fig_height;
      width: $fig_width;
      border-radius: 30px;
      background-image: url("../../../assets/shop.jpg");
      background-size: $fig_width $fig_height;
      background-repeat: no-repeat;
      margin: 0;
    }
  }
}
</style>
